import axios from 'axios';
/**
 * add to checklist post api
 * to add to checklist  */
export async function addToChecklist(formData) {
  let result = '';
  await axios.post(`${process.env.VUE_APP_JAVA_API_URL}/regulation_check`, formData)
    .then((response) => {
      if (response.status === 200) {
        result = response.data;
        console.log('result', response.data);
      }
    })
    .catch((err) => {
      result = err.response.data;
      console.log('add check list java api error', err.response); // eslint-disable-line no-console
    });
  return result;
}

/**
 * getProductRegulations get api
 * to regulations list */
export async function getProductRegulations(typeId, regId) {
  let result = [];
  await axios.get(`${process.env.VUE_APP_JAVA_API_URL}/regulation_check/${typeId}/${regId}
  `)
    .then((response) => {
      if (response.status === 200) {
        result = response.data;
      }
    })
    .catch((err) => {
      console.log('get headline java api error', err); // eslint-disable-line no-console
    });
  return result;
}

/**
 * getProductRegulations get api
 * to regulations list */
export async function isRegulationChecked(id) {
  let result = [];
  await axios.get(`${process.env.VUE_APP_JAVA_API_URL}/is_regulation_checked?registrationId=${id}`)
    .then((response) => {
      if (response.status === 200) {
        result = response.data;
      }
    })
    .catch((err) => {
      console.log('get headline java api error', err); // eslint-disable-line no-console
    });
  return result;
}
/**
 * getRegulations get api
 * to regulations list */
export async function getPurchaseDetails() {
  let result = [];
  await axios.get(`${process.env.VUE_APP_JAVA_API_URL}/purchase?showAll=true`)
    .then((response) => {
      if (response.status === 200) {
        result = response.data;
      }
    })
    .catch((err) => {
      console.log('get regulation check java api error', err); // eslint-disable-line no-console
    });
  return result;
}
/* delete alerts api */
export async function deleteAndAddToChecklist(id) {
  let result = [];
  await axios.delete(`${process.env.VUE_APP_JAVA_API_URL}/alerts/${id}`)
    .then((response) => {
      // if (response.status === 200 && response.data.user_data) {
      result = response;
      // }
    })
    .catch((err) => {
      console.log('delete alerts java api error', err); // eslint-disable-line no-console
    });
  return result;
}
